import { FC } from "react"
import { Control, FieldValues, FieldErrors, FieldError } from "react-hook-form"
import { extensionSelectOptions } from "../../model"
import { FormbuilderInput } from "../formbuilder-input"

interface FileFormProps {
    control: Control<FieldValues, any>
    errors: FieldErrors<FieldValues>
}

export const FileForm: FC<FileFormProps> = ({ control, errors }) => {
    return (
        <>
            <FormbuilderInput
                control={control}
                label={"Типы файлов"}
                isMulti
                id={"allowed_extensions"}
                error={errors['allowed_extensions'] as FieldError}
                type="select"
                options={extensionSelectOptions}
                required={true}
                placeholder="Укажите типы файлов"
            />
        </>
    )
}